import type { Climb } from '../../types/climb';
import { climbUrl } from '../../utils/climb-url';

/**
 * A climb that was put up without its photograph, and may be given one.
 *
 * A gym's admin can enter a wall as a list — grade and hold type, no picture —
 * because that is the only way a hundred problems get entered in an evening. The
 * pictures then come from whoever is standing at the wall, so wherever such a
 * climb is shown a camera stands where its picture would be: in the thumbnail's
 * box on a list row (`ClimbRow`), and in the whole frame on the climb's own page
 * (`ClimbPhotoPrompt`). Both lead to the same place — see `useAddClimbPhoto` —
 * and the server agrees with this predicate
 * (`Api::ClimbsController#fills_in_missing_photo?`).
 *
 * Under a gym alone, because that is where the editor this leads to lives: a
 * crag's routes are corrected from the panel, and a competition's from its own
 * pages. And never a board problem, which is drawn on the wall's own photograph
 * and so has none of its own to be missing.
 */
export function wantsPhoto(climb: Climb): boolean {
  return !climb.has_image && climb.type !== 'BoardClimb' && climb.location?.type === 'Gym';
}

/** Where a climb is given its picture — and its circles, which is the same page. */
export function climbPhotoEditorPath(climb: Climb): string {
  return `${climbUrl(climb)}/edit`;
}
